import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import DoctorList from "./doctorList"

const DoctorListContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <DoctorList  />
        </>
      </div>
    </div>
  )
}

export default DoctorListContainer